import ShortUniqueId from 'short-unique-id';

export const getShortUniqueId = new ShortUniqueId({ length: 10 });
